// src/containers/SiteHeader.tsx
import React from "react";
import Header from "components/Header/Header";

const SiteHeader = () => {
  return <Header />;
};

export default SiteHeader;